@if (form) {
  <div class="row" [formGroup]="form">
    <div class="col-12 col-md-6" formGroupName="deliveryAddress">
      @if (deliveryAddresses.length > 0) {
        <div class="form-group">
          <label for="deliveryLocation" class="control-label" translate>DELIVERY_LOCATION</label>
          <select
            name="deliveryLocation"
            id="deliveryLocation"
            class="form-control form-select"
            (change)="deliveryLocationSelected($event.target.value)"
          >
            <option [value]="undefined" [selected]="selectedDeliveryAddressIndex === undefined">
              <!-- Blank option -->
            </option>
            <option
              [value]="idx"
              [selected]="selectedDeliveryAddressIndex === idx"
              *ngFor="let option of deliveryAddresses; let idx = index"
            >
              {{ favouriteAddressIds.has(option.address1 + option.address2 + option.city + option.countryCode + option.name + option.zipCode) ? '★ ' : '' }}
              {{ option.name }} - {{ option.address1 }}{{ option.city ? ', ' + option.city : '' }}
            </option>
          </select>
        </div>
      }

      <fieldset [disabled]="!editDeliveryAddressEnabled">
        <div class="form-group">
          <label for="name" class="control-label" translate>NAME</label>
          <input class="form-control" type="text" name="name" id="name" [formControlName]="'name'" />
        </div>
        <div class="form-group">
          <label for="address1" class="control-label" translate>ADDRESS</label>
          <input class="form-control" type="text" name="address1" id="address1" [formControlName]="'address1'" />
        </div>
        <div class="form-group">
          <label for="address2" class="control-label" translate>ADDRESS_2</label>
          <input class="form-control" type="text" name="address2" id="address2" [formControlName]="'address2'" />
        </div>
        <div class="form-group">
          <label for="zipCode" class="control-label" translate>ZIP</label>
          <input class="form-control" type="text" name="zipCode" id="zipCode" [formControlName]="'zipCode'" />
        </div>
        <div class="form-group">
          <label for="city" class="control-label" translate>CITY</label>
          <input class="form-control" type="text" name="city" id="city" [formControlName]="'city'" />
        </div>

        <lib-meta-select-input
          [formControlName]="'countryCode'"
          table="countries"
          metaId="alpha-2"
          metaDisplay="name"
          gungTranslate="COUNTRY"
        >
        </lib-meta-select-input>
      </fieldset>

      <input
        type="checkbox"
        id="EDIT_DELIVERY_ADDRESS"
        name="EDIT_DELIVERY_ADDRESS"
        (change)="changeEditStatus($event)"
      />
      <label for="EDIT_DELIVERY_ADDRESS" class="ml-2" translate>EDIT_DELIVERY_ADDRESS</label>
    </div>
    <div class="col-12 col-md-6">
      <div class="form-group">
        <label for="externalText" class="control-label" translate>MESSAGE</label>
        <textarea
          class="form-control"
          rows="5"
          name="externalText"
          id="externalText"
          [formControlName]="'externalText'"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="externalReference" class="control-label" translate>REFERENCE_NO</label>
        <input
          class="form-control"
          type="text"
          name="externalReference"
          id="externalReference"
          [formControlName]="'externalReference'"
        />
      </div>
      @if (contactIds && contactIds.length > 0) {
        <lib-gung-select-option-input
          gungTranslate="CUSTOMER_CONTACT"
          [optionsList]="contactIds"
          formControlName="contactId"
        >
        </lib-gung-select-option-input>
      }
      <lib-confirmation-emails
        [emails]="checkout.extra.confirmationEmails"
        (emailsUpdated)="checkout.extra.confirmationEmails = $event"
      ></lib-confirmation-emails>
    </div>
    <div class="row">
      <div class="col-12">
        <ngb-alert class="mt-2" *ngIf="alert" [type]="alert.type" (close)="alert = null">
          {{ alert.message | translate }}
        </ngb-alert>
      </div>
    </div>
  </div>
}
